/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Code_Field_LabelInputs */

const en_us2_auth_code_field_label = /** @type {(inputs: Auth_Code_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-digit code`)
};

const pt_br2_auth_code_field_label = /** @type {(inputs: Auth_Code_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de 6 dígitos`)
};

const es_419_auth_code_field_label = /** @type {(inputs: Auth_Code_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de 6 dígitos`)
};

const pt_pt2_auth_code_field_label = /** @type {(inputs: Auth_Code_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de 6 dígitos`)
};

const fr_fr2_auth_code_field_label = /** @type {(inputs: Auth_Code_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code à 6 chiffres`)
};

const de_de2_auth_code_field_label = /** @type {(inputs: Auth_Code_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-stelliger Code`)
};

const it_it2_auth_code_field_label = /** @type {(inputs: Auth_Code_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice di 6 cifre`)
};

/**
* | output |
* | --- |
* | "6-digit code" |
*
* @param {Auth_Code_Field_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_code_field_label = /** @type {((inputs?: Auth_Code_Field_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Code_Field_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_code_field_label(inputs)
	if (locale === "es-419") return es_419_auth_code_field_label(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_code_field_label(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_code_field_label(inputs)
	if (locale === "de-DE") return de_de2_auth_code_field_label(inputs)
	if (locale === "it-IT") return it_it2_auth_code_field_label(inputs)
	return en_us2_auth_code_field_label(inputs)
});
export { auth_code_field_label as "auth.code_field_label" }